// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimApprovalStatusCodeDto
 */
export interface IClaimApprovalStatusCodeDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimApprovalStatusCodeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusCodeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusCodeDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimApprovalStatusCodeDto
     */
    is_visible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusCodeDto
     */
    category?: string;
}

/**
 * Check if a given object implements the IClaimApprovalStatusCodeDto interface.
 */
export function instanceOfIClaimApprovalStatusCodeDto(value: object): value is IClaimApprovalStatusCodeDto {
    return true;
}

export function IClaimApprovalStatusCodeDtoFromJSON(json: any): IClaimApprovalStatusCodeDto {
    return IClaimApprovalStatusCodeDtoFromJSONTyped(json, false);
}

export function IClaimApprovalStatusCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimApprovalStatusCodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'is_visible': json['isVisible'] == null ? undefined : json['isVisible'],
        'category': json['category'] == null ? undefined : json['category'],
    };
}

export function IClaimApprovalStatusCodeDtoToJSON(json: any): IClaimApprovalStatusCodeDto {
    return IClaimApprovalStatusCodeDtoToJSONTyped(json, false);
}

export function IClaimApprovalStatusCodeDtoToJSONTyped(value?: IClaimApprovalStatusCodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'isVisible': value['is_visible'],
        'category': value['category'],
    };
}

